import { team, user, servicePermission } from '@/common/basis/root-injector'
import { router } from '@/router/index'
import { ElMessage } from 'element-plus'
import { useRolePermStore } from '@/services/role-perm.service'
import { isPathNotExists } from '@/router/nav-menu'
import { toLoginPage } from '@/services/login.service'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'

const NO_BLOCK_ROUTES = [
  'Index',
  'preview',
  'CloudLibraryUpdate',
  'LoginTransitView',
  'CascadeLoginView',
  'AuthorizeView',
  'repairHelpView',
  'subscribeHelpView',
  'linuxRepairHelpView',
  'domainDeployment',
  'watermarkDecryption',
  'RemoteVnc',
  'PasswordReset',
  'MfaReset',
  'ResetPassword',
  'ResetMfa',
]

router.beforeResolve((to, from, next) => {
  /** 缓存页面 show_from 来源 */
  if (to.query.show_from) {
    sessionStorage.setItem('report_show_from', to.query.show_from as string)
  }

  if (isPathNotExists({ currentPath: to.path, isExclude: (menu) => menu.isHide })) {
    router.replace('/dashboard/overview')
    return
  }

  if (NO_BLOCK_ROUTES.includes(to.name as string)) {
    next()
    return
  }

  const noPerm = isPathNotExists({
    currentPath: to.path,
    isExclude: (menu) => {
      if (menu.isHide) return true
      if (menu.rolePermKey && !useRolePermStore().cmRolePermMapBe[menu.rolePermKey]) return true
      // 日文专版：服务级权限 hasPermission=false 时阻止路由访问
      if (IS_JP_ONLY_BUILD && menu.servicePermissionKey && !servicePermission.getHasPermission(menu.servicePermissionKey)) return true
      return false
    }
  })

  if (user.hasUser()) {
    if (to.name === 'Team') {
      next()
    } else if (!team.hasSelectedTeam()) {
      router.replace({ path: '/team' })
    } else if (noPerm) {
      ElMessage.warning('您没有该功能的权限')
      router.replace('/dashboard/overview')
    } else {
      next()
    }
  } else {
    if (to.name === 'Login') {
      next()
    } else {
      toLoginPage()
    }
  }
})
